import { render } from "./activationList.vue?vue&type=template&id=0ee47886&scoped=true"
import script from "./activationList.vue?vue&type=script&lang=js"
export * from "./activationList.vue?vue&type=script&lang=js"

import "./activationList.vue?vue&type=style&index=0&id=0ee47886&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ee47886"

export default script